import collectionService from "../../services/collectionService";
import Vue from 'vue'
import { distinctById } from "@/utils";
import axios from "axios";

var collection_request;

const state = {
    collections: [],
    filters: {
        state: 'K',
        categories: undefined,
        place: undefined,
        client: undefined,
        product_id: undefined,
    },
    loading_collections: false,
    next_page: undefined,

    selected_collections: [],
    select_mode: false,
};

const actions = {
    fastClear({commit}) {
        commit('clearData')
    },
    getCollections({commit, state}, params) {

        if (collection_request) {
            collection_request.cancel();
        }
        const CancelToken = axios.CancelToken;
        collection_request = CancelToken.source();

        if (state.next_page === null) {
            return
        }
        state.loading_collections = state.next_page === undefined;
        params.cursor = state.next_page;
        return new Promise((resolve, reject) => {

            if (['hide_paid', 'hide_collection'].includes(params.view)) {
                commit('setCollections', {next: null, collections: []});
                state.loading_collections = false;
                collection_request = null;
                resolve()
                return
            }

            collectionService.fetchCollections({params, token: collection_request.token})
                .then(data => {
                    let collections = distinctById(state.collections.concat(data.results));
                    commit('setCollections', {next: data.next, collections});
                    state.loading_collections = false;
                    collection_request = null;
                    resolve()
                })
                .catch((error) => {
                    console.log('error', error)
                    if (error.__CANCEL__) {
                        return
                    }
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о сборах.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.loading_collections = false;
                    reject()
                });
        })
    },
    getSharedCollections({commit, state}, params) {
        if (state.next_page === null) {
            return
        }
        state.loading_collections = state.next_page === undefined;
        params.cursor = state.next_page;
        return new Promise((resolve, reject) => {
            collectionService.fetchSharedCollections(params)
                .then(data => {
                    let collections = distinctById(state.collections.concat(data.results));
                    commit('setCollections', {next: data.next, collections});
                    state.loading_collections = false;
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о сборах.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.loading_collections = false;
                    reject()
                });
        })
    },
    addCollection({commit}, collection) {
        return new Promise((resolve, reject) => {
            collectionService.postCollection(collection)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve(response)
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось добавить сбор.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    getCollection({commit}, collection_id) {
        return new Promise((resolve, reject) => {
            collectionService.getCollection(collection_id)
                .then((collection) => {
                    commit('addCollection', collection)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о сборе.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    editCollection({commit}, collection) {
        return new Promise((resolve, reject) => {
            collectionService.editCollection(collection)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve(response)
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить сбор.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    deleteCollection({commit}, collection) {
        return new Promise((resolve, reject) => {
            collectionService.deleteCollection(collection.id)
                .then(() => {
                    commit('deleteCollection', collection.id)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось удалить сбор.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    togglePrepayment({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.togglePrepayment(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось установить предоплату сбора.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    toggleCollected({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.toggleCollected(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось пометить сбор собраным.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    toggleStop({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.toggleStop(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось поменять статус стопа сбора.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    actionPosition({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.actionPosition(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось совершить действие с позицией сбора.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    drawLottery({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.drawLottery(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve(response)
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось провести лотерею.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    takeLottery({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.takeLottery(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось принять участие в лотереи.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    sendToPurchase({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.sendToPurchase(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось отправить в закупку сбор.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    duplicate({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.duplicate(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось сделать дубликат сбора.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    setState({commit}, data) {
        return new Promise((resolve, reject) => {
            collectionService.setState(data)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось сменить статус сбора.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    toggleSorted({commit}, collection_id) {
        return new Promise((resolve, reject) => {
            collectionService.toggleSorted(collection_id)
                .then((response) => {
                    commit('updateCollection', response)
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось пометить сбор как отсортированный.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    setEdit(store, params) {
        return new Promise((resolve, reject) => {
            collectionService.setEdit(params)
                .then(() => {
                    resolve(params)
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось отредактировать сбор.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    }
};

const mutations = {
    setCollections(state, {next, collections}) {
        state.next_page = next;
        state.collections = collections;
    },
    updateCollection(state, collection) {
        const index = state.collections.findIndex(obj => obj.id === collection.id);
        if (index !== -1) {
            // Vue.set(state.collections, index, collection);
            state.collections.splice(index, 1, collection);
        }
        if (collection.main_collection) {
            const main_index = state.collections.findIndex(obj => obj.id === collection.main_collection);
            const duplicates = state.collections[main_index].duplicates
            const index = duplicates.findIndex(obj => obj.id === collection.id);
            duplicates.splice(index, 1, collection);
        }
    },
    deleteCollection(state, collection_id) {
        const index = state.collections.findIndex(obj => obj.id === collection_id);
        if (index !== -1) {
            state.collections.splice(index, 1)
        }
    },
    deleteDuplicate(state, collection) {
        const main_index = state.collections.findIndex(obj => obj.id === collection.main_collection);
        const duplicates = state.collections[main_index].duplicates
        const index = duplicates.findIndex(obj => obj.id === collection.id);
        duplicates.splice(index, 1)
    },
    addToSelected(state, collection) {
        if (!state.selected_collections.includes(collection.id)) {
            state.selected_collections.push(collection.id);
        }
    },
    removeFromSelected(state, collection) {
        const index = state.selected_collections.findIndex(obj => obj === collection.id);
        state.selected_collections.splice(index, 1);
    },
    setFilters(state, filters) {
        if (filters.state !== undefined) {
            state.filters.state = filters.state;
        }
        if (filters.categories !== undefined) {
            state.filters.categories = filters.categories;
        }
        if (filters.client !== undefined) {
            state.filters.client = filters.client;
        }
        state.filters.product_id = filters.product_id;
    },
    addCollection(state, collection) {
        const index = state.collections.findIndex(obj => obj.id === collection.id)
        if (index !== -1) {
            Vue.set(state.collections, index, collection)
        } else {
            state.collections.unshift(collection)
        }
    },
    clearData(state) {
        state.move_mode = false;
        state.selected_collections = [];
        state.next_page = undefined;
        state.collections = [];
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}